import React, { Component } from "react";
import onClickOutside from "react-onclickoutside";
import {
  Container,
  Input,
  IconContainer,
  Notice,
  ListContainer,
  List,
  AddButton
} from "./style";
import { Highlighter } from "../../lib/highlighter";
import { Spinner } from "../../components/loading";
class Autocomplete extends Component {
  constructor(props) {
    super(props);
    this.state = {
      keyword: "",
      listStatus: false,
      listPosition: "bottom",
      searching: false
    };
    this.selector = React.createRef();
  }
  openList() {
    const rect = this.selector.current.getBoundingClientRect();
    let listPosition = "bottom";
    if (window.innerHeight - rect.bottom < 230) {
      listPosition = "top";
    }
    this.setState({
      listStatus: true,
      listPosition: listPosition
    });
  }
  handleClickOutside = evt => {
    this.setState({
      listStatus: false,
      keyword: "",
      searching: false
    });
  };
  handleInput(e) {
    this.setState({
      keyword: e.target.value,
      searching: true
    });
  }
  handleItemClick(value) {
    const { input } = this.props;
    this.setState(
      {
        listStatus: false,
        keyword: "",
        searching: false
      },
      input.onChange(value)
    );
  }
  addButtonText() {
    const { keyword } = this.state;
    const { addButtonText } = this.props;
    if (keyword) {
      return keyword;
    } else {
      return addButtonText;
    }
  }
  items() {
    const { listItems } = this.props;
    const { keyword } = this.state;
    let filteredArray = [];
    if (keyword !== "") {
      listItems.forEach(items => {
        if (items.value.includes(keyword)) {
          if (filteredArray.indexOf(items) === -1) {
            filteredArray.push(items);
          }
        }
      });
      return filteredArray;
    } else {
      return listItems;
    }
  }
  icons() {
    const { listStatus, keyword, searching } = this.state;
    const { input } = this.props;
    if (listStatus || input.value.value) {
      return (
        <IconContainer
          status={listStatus}
          onClick={() => {
            this.handleClickOutside();
          }}
        >
          {(keyword !== "" || input.value.value) && !searching ? (
            <i
              onClick={e => {
                e.stopPropagation();
                this.handleItemClick(null);
              }}
              className="icon mapsa-close"
            />
          ) : (
            ""
          )}
          <i
            onClick={e => {
              e.stopPropagation();
              if (listStatus) {
                this.handleClickOutside();
              } else {
                this.openList();
              }
            }}
            className="icon mapsa-arrow expand-icon"
          />
        </IconContainer>
      );
    }
  }
  addButtonView() {
    const { keyword } = this.state;
    const items = this.items();
    if (this.props.addComponent) {
      return (
        <AddButton
          borderTop={items.length}
          onClick={() => {
            this.setState({listStatus:false});
            this.props.addComponent(keyword);
          }}
        >
          <i className="icon mapsa-plus" />
          افزودن &nbsp;
          <span>{this.addButtonText()}</span>
        </AddButton>
      );
    }
  }
  favoriteView(status, key) {
    if (typeof status === "undefined") {
      return null;
    }
    if (status) {
      return (
        <span
          className="favorite"
          onClick={e => {
            e.stopPropagation();
            if (this.props.doFavorite) {
              this.props.doFavorite(key, !status);
            }
          }}
        >
          <i className="icon mapsa-filled-favourites-star" />
        </span>
      );
    } else {
      if (this.props.favLoading === key) {
        return (
          <span className="fav-loading">
            <Spinner />
          </span>
        );
      } else {
        return (
          <span
            className="not-favorite"
            onClick={e => {
              e.stopPropagation();
              if (this.props.doFavorite) {
                this.props.doFavorite(key, !status);
              }
            }}
          >
            <i className="icon mapsa-favourites-star" />
          </span>
        );
      }
    }
  }
  inputValue() {
    const { input } = this.props;
    const { keyword, searching } = this.state;
    if (searching) {
      return keyword;
    } else {
      return input.value.value ? input.value.value : "";
    }
  }
  render() {
    const { placeholder, listLoading, disabled } = this.props;
    const { keyword, listStatus, listPosition } = this.state;

    const items = this.items();
    const date = new Date();
    const timestamp = date.getTime();
    return (
      <Container ref={this.selector}>
        <Input
          placeholder={placeholder}
          value={this.inputValue()}
          disabled={disabled}
          onChange={this.handleInput.bind(this)}
          onFocus={() => {
            this.openList();
          }}
          autoComplete={`off${timestamp}`}
        />
        {this.icons()}
        <Notice>
          {this.props && this.props.meta ? this.props.meta.error : ""}
        </Notice>
        <ListContainer
          status={listStatus}
          loading={listLoading ? listLoading.toString() : 'false'}
          listPosition={listPosition}
        >
          <div className="loading">
            <div className="spinner-container">
              <div className="lds-dual-ring" />
            </div>
          </div>
          <List>
            {items.map(item => {
              return (
                <li
                  key={item.key}
                  onClick={() => {
                    this.handleItemClick(item);
                  }}
                >
                  <span className="label">{item.label}</span>
                  <span
                    className="value"
                    dangerouslySetInnerHTML={{
                      __html: Highlighter(keyword, item.value)
                    }}
                  />
                  {this.favoriteView(item.is_favorite, item.key)}
                </li>
              );
            })}
          </List>
          {this.addButtonView()}
        </ListContainer>
      </Container>
    );
  }
}
export default onClickOutside(Autocomplete);
